export default "__VITE_ASSET__1dc28584__"